import { render, staticRenderFns } from "./HistoryTab.vue?vue&type=template&id=2fead0c4&scoped=true"
import script from "./HistoryTab.vue?vue&type=script&lang=ts"
export * from "./HistoryTab.vue?vue&type=script&lang=ts"
import style0 from "./HistoryTab.vue?vue&type=style&index=0&id=2fead0c4&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fead0c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fead0c4')) {
      api.createRecord('2fead0c4', component.options)
    } else {
      api.reload('2fead0c4', component.options)
    }
    module.hot.accept("./HistoryTab.vue?vue&type=template&id=2fead0c4&scoped=true", function () {
      api.rerender('2fead0c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/HistoryTab.vue"
export default component.exports